import { YELLOW_LIGHT } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    titleDrawer: {
      display: 'flex',
      verticalAlign: 'center'
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '16px'
    },
    commerceIcon: {
      borderRadius: '50%'
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    divider: {
      marginTop: '8px',
      marginBottom: '8px'
    },
    footerInfo: {
      backgroundColor: YELLOW_LIGHT,
      borderRadius: '10px',
      padding: '12px',
      marginTop: '16px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      verticalAlign: 'center'
    },
    footerTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      paddingLeft: '8px'
    },
    containerDrawer: {
      padding: '32px'
    }
  };
});
